import config from '../../config';

import rejectShiftModalHtml from './rejectShiftModal.html';

const SHIFT_ACCEPTANCE_NOTIFICATION_TYPES = ['shift_pending_acceptance', 'shift_rejected'];

export default class ShiftAcceptanceUtils {
  constructor(Authentication, EventCollection, sdk, $uibModal) {
    'ngInject';

    Object.assign(this, { Authentication, EventCollection, sdk, $uibModal });
    this.SHIFT_REJECTED_STATUS = sdk('constants').SHIFT_REJECTED_STATUS;
    this.isShiftPendingAcceptance = sdk('helpers/shiftAcceptanceUtils').isShiftPendingAcceptance;
    this.isShiftRejected = sdk('helpers/shiftAcceptanceUtils').isShiftRejected;
  }

  shouldShowAcceptanceStatus(shift, notification) {
    const canShowStatus =
      !notification?.type || SHIFT_ACCEPTANCE_NOTIFICATION_TYPES.includes(notification.type);
    const isArchived = notification?.archived;
    return (
      canShowStatus &&
      ((this.isPendingAcceptance(shift) && !isArchived) || this.isRejectedStatus(shift))
    );
  }

  isShiftAcceptanceEnabled() {
    return (
      config.SHIFT_ACCEPTANCE_ENABLED &&
      this.Authentication.isOrgFeatureEnabled('shiftAcceptance') &&
      this.Authentication.user.orgSettings.shiftAcceptanceEnabled
    );
  }

  isPendingAcceptance(shift) {
    return this.isShiftAcceptanceEnabled() && this.isShiftPendingAcceptance(shift);
  }

  isRejectedStatus(shift) {
    return this.isShiftAcceptanceEnabled() && this.isShiftRejected(shift);
  }

  rejectShift(shift, params = {}) {
    const self = this;
    return this.$uibModal.open({
      name: 'RejectShiftCtrl',
      templateUrl: rejectShiftModalHtml,
      controllerAs: 'ctrl',
      size: 620,
      controller($uibModalInstance) {
        'ngInject';

        this.shift = shift;
        this.isRecurrence = params.recurring;
        this.reason = '';
        this.denyShift = async () => {
          if (this.form.$invalid) {
            this.form.$setSubmitted();
            throw 'invalid form';
          }

          await self.EventCollection.rejectShift(shift, this.reason, params);
          $uibModalInstance.close();
        };
        this.recurrenceDescription = shift.recurrenceDaysDescription?.split(' •').join(',');
      },
    }).result;
  }

  getAcceptanceFilterOptions() {
    const { SHIFT_PENDING_ACCEPTANCE_STATUS, SHIFT_REJECTED_STATUS, SHIFT_ACCEPTED_STATUS } =
      this.sdk('constants');

    return this.isShiftAcceptanceEnabled()
      ? [
          { name: 'Confirmed shifts', id: SHIFT_ACCEPTED_STATUS },
          { name: 'Pending shifts', id: SHIFT_PENDING_ACCEPTANCE_STATUS },
          { name: 'Denied shifts', id: SHIFT_REJECTED_STATUS },
        ]
      : [];
  }
}
